<template>
  <v-app>
    <v-main>
      <div class="page">
        <div class="bg-texture"></div>
        <div class="glow"></div>

        <v-card class="reset-card" flat>
            <!-- Logo -->
            <div class="d-flex justify-center mb-2">
                <v-img
                    src="@/assets/logo.png"
                    alt="School Logo"
                    width="120"
                    contain
                    class="flex-grow-0"
                />
            </div>

          <!-- Header -->
          <div class="eyebrow">Preysal Secondary School</div>
          <h1 class="title">Reset Password</h1>

            <v-alert type="warning" v-if="errorMessage">
                {{ errorMessage }}
            </v-alert>

          <!-- Form -->
          <v-form @submit.prevent="resetPassword" ref="form">

            <v-text-field
              v-model="username"
              label="Username"
              placeholder="Enter your username"
              outlined
              dense
            />

            <v-text-field
                v-model="password"
                label="New Password"
                placeholder="Enter new password"
                outlined
                dense
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show ? 'text' : 'password'"
                @click:append="show = !show" 
            />

            <v-text-field
                v-model="password_confirmation"
                label="Confirm Password"
                placeholder="Confirm new password"
                outlined
                dense
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show ? 'text' : 'password'"
                @click:append="show = !show" 
            />

            <v-btn
              class="reset-btn"
              type="submit"
              block
              large
              :loading="loading"
            >
              Reset Password
            </v-btn>
          </v-form>

          <!-- <a href="/" class="back-link">← Back to Login</a> -->
        </v-card>
        <v-overlay
            :value="overlay"
            opacity="0.8"
            z-index="10"                    
        >
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>                   
        </v-overlay>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

export default {
  name: "ResetPassword",

  data() {
    return {
      username: "",
      password: "",
      password_confirmation: "",
      loading: false,
      show: false,
      errorMessage: '',
      overlay: false,
    };
  },

  methods: {
    ...mapActions({
        postNewPassword: 'auth/changePassword',
    }),

    ...mapMutations({
        setNewPassword: 'auth/setNewPassword',
        setAuthenticated: 'auth/setAuthenticated',
        setResetPassword: 'auth/setResetPassword',
        setPasswordWasReset: 'auth/setPasswordWasReset',
    }),

    async resetPassword() {
      this.loading = true;
      this.overlay = true;

      try {
        const payload = {
          username: this.username,
          password: this.password,
          password_confirmation: this.password_confirmation
        };

        if(!payload.username || !payload.password || !payload.password_confirmation){
            // throw new Error('Please enter your username and password');
            this.errorMessage = 'Please enter your username and password';
            return;
        }
        
        if(payload.password !== payload.password_confirmation){
            this.errorMessage = 'Passwords do not match';
            return;
        }

        this.setNewPassword(payload);
        this.overlay = true;
        
        await this.postNewPassword();
        this.setAuthenticated(false);
        sessionStorage.setItem('authenticated', false);

        this.setResetPassword(0);
        sessionStorage.setItem('resetPassword', 0);

        this.setPasswordWasReset(true);
        sessionStorage.setItem('passwordReset', true);
        this.$router.replace('/');


      } catch (error) {
        console.log(error.response || error);
      } finally {
        this.loading = false;
        this.overlay = false;
      }
    }
  }
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  position: relative;
  overflow: hidden;
  background: #faf6ef;
}

/* background pattern */
.bg-texture {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(circle, rgba(27,33,66,0.05) 1px, transparent 1px);
  background-size: 28px 28px;
  opacity: 0.6;
}

/* glow effect */
.glow {
  position: absolute;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(201,152,47,0.18), transparent 70%);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* card */
.reset-card {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 420px;
  padding: 40px;
  border-radius: 24px;
  border: 1px solid rgba(27,33,66,0.06);
}

/* logo */
.logo-wrap {
  text-align: center;
  margin-bottom: 24px;
}

/* small heading */
.eyebrow {
  text-align: center;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.25em;
  color: #716c62;
  margin-bottom: 8px;
}

/* title */
.title {
  text-align: center;
  margin: 0 0 10px;
  font-family: 'Fraunces', serif;
  font-size: 32px;
  color: #1B2142;
}

/* subtitle */
.subtitle {
  text-align: center;
  font-size: 14px;
  color: #716c62;
  margin-bottom: 24px;
}

/* button */
.reset-btn {
  background: linear-gradient(135deg, var(--v-primary-base), var(--v-primary-lighten1));
  color: white;
  font-weight: 600;
  border-radius: 14px;
}

/* back link */
.back-link {
  display: block;
  text-align: center;
  margin-top: 20px;
  color: #2C3568;
  text-decoration: none;
  font-size: 14px;
}
</style>